import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig, tokenConfigUpload } from "./auth";

import { GET_COMPANIES, GET_COMPANY, CREATE_COMPANY, EDIT_COMPANY, DELETE_COMPANY, ARCHIVE_COMPANY, GET_SEARCHABLE_COMPANIES, GET_INDUSTRIES } from "./types";

// GET ALL COMPANIES
export const getCompanies = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/company/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_COMPANIES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET SEARCHABLE COMPANIES
export const getSearchableCompanies = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/company/company-searchable`)
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_SEARCHABLE_COMPANIES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};
// GET COMPANY INFORMATION
//export const getCompany = (id) => (dispatch, getState) => {
export const getCompany = () => (dispatch, getState) => {
    axios
        //.get(`/v0/api/company/${id}/`, tokenConfig(getState))
        .get(`/v0/api/company/get-session-company`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_COMPANY,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// EDIT COMPANY
export const editCompany = (id, company) => (dispatch, getState) => {
    axios
        .put(`/v0/api/company/${id}/`, company, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: EDIT_COMPANY,
                    payload: res.data,
                });
            }
            dispatch(createMessage({ success: "Company updated." }));
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// UPLOAD COMPANY ICON
export const uploadCompanyIcon = (file_name, formData) => (dispatch, getState) => {
    axios
        .post(`/v0/api/core/upload/company-icon/${file_name}/`, formData, tokenConfigUpload(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_COMPANY,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

// DELETE COMPANY
export const deleteCompany = (id) => (dispatch, getState) => {
    axios
        .delete(`/v0/api/company/${id}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: DELETE_COMPANY,
                    payload: id,
                });
                dispatch(createMessage({ success: "Company deleted successfully." }));
            }
        })
        .catch((err) => console.log(err));
};

// CREATE COMPANY
export const addCompany = (company) => (dispatch, getState) => {
    axios
        .post("/v0/api/company/", company, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: CREATE_COMPANY,
                    payload: res.data,
                });
                dispatch(createMessage({ success: "Company successfully created." }));
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};

//export const getCompany = (id) => (dispatch, getState) => {
export const getIndustries = () => (dispatch, getState) => {
    axios
        //.get(`/v0/api/company/${id}/`, tokenConfig(getState))
        .get(`v0/api/company/get-industries`)
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }))
            } else {
                dispatch({
                    type: GET_INDUSTRIES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({...err.response.data, ...err.response.status})));
};